import { createClient } from "@supabase/supabase-js";
import { appEnvironment, hasSupabaseConfiguration } from "./env";

export const supabase = hasSupabaseConfiguration
  ? createClient(appEnvironment.supabaseUrl, appEnvironment.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // Email confirmation is deliberately verified only by the page button.
        detectSessionInUrl: !/^\/auth\/confirm\/?$/.test(window.location.pathname),
      },
    })
  : null;
